import { makeActionCreator } from 'crazyEditor/redux/helpers';
import update from 'immutability-helper';
import _ from 'lodash';
import {
  ERROR_FILE_UPLOAD_STATUS,
  CANCELED_FILE_UPLOAD_STATUS,
  UPLOADED_FILE_UPLOAD_STATUS,
  LOADING_FILE_UPLOAD_STATUS,
} from 'MyAccount/AssetManager/ImageManager/consts';

const UPDATE_FOLDERS = 'images/UPDATE_FOLDERS';
const UPDATE_FILES = 'images/UPDATE_FILES';
const DELETE_FILES = 'images/DELETE_FILES';
const RENAME_FILE = 'images/RENAME_FILE';
const UPLOAD_FILES = 'images/UPLOAD_FILES';
const MOVE_FILES = 'images/MOVE_FILES';
const CHANGE_SEARCH_FILE = 'images/CHANGE_SEARCH_FILE';
const DELETE_FOLDER = 'images/DELETE_FOLDER';
const PUSH_NEW_FOLDER = 'images/PUSH_NEW_FOLDER';
const RENAME_FOLDER = 'images/RENAME_FOLDER';
const CHANGE_FOLDER = 'images/CHANGE_FOLDER';
const UPDATE_SEARCH = 'images/UPDATE_SEARCH';

const PUSH_IMAGE_TO_BAR = 'images/PUSH_IMAGE_TO_BAR';
const REMOVE_ALL_IMAGES_FROM_BAR = 'images/REMOVE_ALL_IMAGES_FROM_BAR';
const CHANGE_FILE_STATUS_SUCCESS = 'images/CHANGE_FILE_STATUS_SUCCESS';
const CHANGE_FILE_STATUS_ERROR = 'images/CHANGE_FILE_STATUS_ERROR';
const RETRY_UPLOAD_FILE_IN_BAR = 'images/RETRY_UPLOAD_FILE_IN_BAR';
const CHANGE_FILE_UPLOAD_PERCENT = 'images/CHENGE_FILE_UPLOAD_PERCENT';

const PUSH_SELECTED_IMAGES = 'images/PUSH_SELECTED_IMAGES';
const POP_SELECTED_IMAGES = 'images/POP_SELECTED_IMAGES';
const SET_SELECTED_IMAGES = 'images/SET_SELECTED_IMAGES';

const CHANGE_SORT_DIRECTION = 'images/CHANGE_SORT_DIRECTION';
const CHANGE_SORT_FIELD = 'images/CHANGE_SORT_FIELD';

const OPEN_SNACKBAR = 'images/OPEN_SNACKBAR';
const CLOSE_SNACKBAR = 'images/CLOSE_SNACKBAR';

const CHANGE_VIEW = 'images/CHANGE_VIEW';

function createStateUpdateAtFolderPath(action, folderStateUpdate) {
  const {currentFolder: {path = '/'}, resourceType} = action.data;
  const stateUpdate = {[resourceType]: {}};
  const spittedPath = path.split('/');
  spittedPath.shift(); // remove first empty folder
  let currentStateUpdate = stateUpdate[resourceType];
  while (!_.isEmpty(spittedPath)) {
    const nextFolder = spittedPath.shift();
    if (_.isEmpty(nextFolder)) {
      break;
    }
    currentStateUpdate.folders = {[nextFolder]: {}};
    currentStateUpdate = currentStateUpdate.folders[nextFolder];
  }
  _.assign(currentStateUpdate, folderStateUpdate);
  return stateUpdate;
}

function doUpdateFolders(state, action) {
  const {folders} = action.data;
  return update(state, createStateUpdateAtFolderPath(action, {$merge: {...action.data, folders: _.keyBy(folders, 'name')}}));
}

function doUpdateFiles(state, action) {
  const {files, currentFolder} = action.data;
  return update(state, createStateUpdateAtFolderPath(action, { currentFolder: {$set: currentFolder}, files: {$set: files}}));
}

function doDeleteFiles(state, action) {
  let files = action.data;
  const path = files[0].folder;
  const deleteGroup = [];
  files = _.filter(files, file => {
    if (path !== action.folder) {
      deleteGroup.push(file);
    }
    return path !== file.folder;
  });
  let newState = update(state, createStateUpdateAtFolderPath({
    data: {
      currentFolder: { path },
      resourceType: 'Images',
    },
  }, {
    files: {
      $apply: (items) => {
        return _.filter(items, item => {
          return _.findIndex(deleteGroup, del => del.name === item.name) < 0;
        });
      },
    }
  }));

  if (!_.isEmpty(files)) {
    newState = doDeleteFiles(newState, { data: files });
  }
  return newState;
}

function doRenameFile(state, action) {
  const { name, newName } = action.data;
  return update(state, createStateUpdateAtFolderPath(action, {
    files: {
      $apply: (files) => files.map((file) => ({
        ...file,
        name: file.name === name ? newName : file.name
      })),
    },
  }));
}

function doMoveFiles(state, action) {
  const newFolder = action.data.path;
  let files = action.data.files;
  const removeGroup = [];
  const pastGroup = [];
  const groupPath = files[0].folder;
  files = _.filter(files, (file) => {
    if (groupPath === file.folder) {
      removeGroup.push(file);
    }
    return groupPath !== file.folder;
  });

  // remove images
  let newState = update(state, createStateUpdateAtFolderPath({
    data: {
      currentFolder: { path: groupPath },
      resourceType: 'Images',
    },
  }, {
    files: {
      $apply: (items) => _.filter(items, item => {
        const index = _.findIndex(removeGroup, rem => rem.name === item.name);
        if (index >= 0) {
          pastGroup.push(item);
        }
        return index < 0;
      }),
    },
  }));

  // past images
  newState = update(newState, createStateUpdateAtFolderPath({
    data: {
      currentFolder: { path: newFolder },
      resourceType: 'Images',
    },
  }, {
    files: {
      $push: pastGroup,
    },
  }));

  if (!_.isEmpty(files)) {
    newState = doMoveFiles(newState, { ...action, data: { ...action.data, files } });
  }
  return newState;
}

function doUploadFiles(state, action) {
  const { currentFolder, date, name, size, resourceType = 'Images' } = action.data;
  return update(state, createStateUpdateAtFolderPath({
    data: {
      currentFolder: { path: currentFolder },
      resourceType: resourceType,
    },
  }, {
    files: {
      $push: [{
        name,
        date,
        size,
      }],
    },
  }));
}

function doChangeSearchFile(state, action) {
  const { searchFile } = action.data;
  return update(state, {
    Images: {
      $apply: Images => ({
        ...Images,
        searchFile,
      })
    },
  });
}

function doDeleteFolder(state, { path }) {
  const folderArr = _.split(path, '/');
  let folderParent = '';
  let deleteFolder = '';
  if (folderArr.length === 1) {
    folderParent = '/';
    deleteFolder = folderArr[0];
  } else {
    folderParent = `/${_.join(_.slice(folderArr, 0, folderArr.length - 1), '/')}/`;
    deleteFolder = _.last(folderArr);
  }
  return update(state, createStateUpdateAtFolderPath({
    data: {
      currentFolder: { path: folderParent },
      resourceType: 'Images',
    },
  }, {
    folders: {
      $apply: folders => _.keyBy(_.filter(folders, folder => folder.name !== deleteFolder), 'name'),
    }
  }));
}

function doAddFolder(state, { data }) {
  const { newFolder, currentFolder: { url = '' } } = data;
  return update(state, {
    Images: {
      folders: {
        $merge: {
          [newFolder]: {
            name: newFolder,
            hasChildren: false,
            files: [],
            currentFolder: {
              path: `/${newFolder}/`,
              url: `${url}${newFolder}/`,
            },
          }
        },
      }
    },
  });
}

const updateUrl = (state, oldPath, path) => update(state, {
  $apply: folders => _.keyBy(_.map(folders, folder => {
    const curFolder = {
      ...folder,
      currentFolder: {
        ...folder.currentFolder,
        url: _.replace(folder.currentFolder.url, oldPath, path),
        path: _.replace(folder.currentFolder.path, oldPath, path),
      },
    };
    if (curFolder.hasChildren) {
      curFolder.folders = updateUrl(folder.folders, oldPath, path);
    }
    return curFolder;
  }), 'name')
});

function doRenameFolder(state, { data }) {
  const { path, newFolderName } = data;
  const pathArr = _.split(_.trim(path, '/'), '/');
  const folderName = _.last(pathArr);
  const parentFolder = pathArr.length > 1 ? `/${_.dropRight(pathArr).join('/')}/` : '/';

  return update(
    state,
    createStateUpdateAtFolderPath(
      {
        data: { currentFolder: { path: parentFolder }, resourceType: 'Images' }
      }, {
        folders: {
          $apply: folders => {
            if (_.has(folders, folderName)) {
              const oldObj = folders[folderName];
              const oldPath = oldObj.currentFolder.path;
              const path = `${parentFolder}${newFolderName}/`;
              const newFolders = {
                ...folders,
                [newFolderName]: {
                  ...oldObj,
                  name: newFolderName,
                  currentFolder: {
                    ...oldObj.currentFolder,
                    path,
                    url: _.replace(oldObj.currentFolder.url, oldPath, path),
                  },
                },
              };
              if (newFolders[newFolderName].hasChildren) {
                newFolders[newFolderName].folders = updateUrl(oldObj.folders, oldPath, path);
              }
              return _.keyBy(_.filter(newFolders, (folder) => folder.name !== folderName), 'name');
            }
            return folders;
          },
        }
      }
    )
  );
}

function createSelectedObject(selected) {
  let sel = selected;
  if (typeof selected === 'string') {
    sel = [selected];
  }
  return _.zipObject(sel, _.fill(new Array(sel.length), true));
}

function pushSelectedImages(state, { selected }) {
  return update(state, {
    Images: {
      selectedImages: {
        $merge: createSelectedObject(selected),
      },
    }
  });
}

function popSelectedImages(state, { selected }) {
  return update(state, {
    Images: {
      selectedImages: {
        $apply: selectedImages => _.omit(selectedImages, typeof selected === 'string' ? [selected] : selected)
      }
    }
  });
}

function setSelectedImages(state, { selected }) {
  return update(state, {
    Images: {
      selectedImages: {
        $set: createSelectedObject(selected),
      }
    }
  });
}

function doPushImageToBar(state, action) {
  const { currentFolder, date, name, size, cancelUpload, retryUpload, url, formData, resourceType = 'Images' } = action.data;
  return update(state, {
    [resourceType]: {
      uploadFiles: {
        $push: [{
          folder: currentFolder,
          name,
          date,
          size,
          cancelUpload,
          retryUpload,
          url,
          formData,
          status: LOADING_FILE_UPLOAD_STATUS,
        }]
      }
    }
  });
}

function doRemoveAllImagesFromBar(state, action) {
  const { resourceType = 'Images' } = action.data;
  return update(state, {
    [resourceType]: {
      uploadFiles: {
        $set: [],
      }
    }
  });
}

function doChangeFileStatusSuccess(state, action) {
  const { currentFolder, name, resourceType = 'Images' } = action.data;
  return update(state, {
    [resourceType]: {
      uploadFiles: {
        $apply: files => _.map(files, file => {
          if (file.name === name && file.folder === currentFolder) {
            return {
              ...file,
              status: UPLOADED_FILE_UPLOAD_STATUS,
            };
          }
          return file;
        }),
      }
    }
  });
}

function doChangeFileStatusError(state, action) {
  const { currentFolder, name, status, error, resourceType = 'Images' } = action.data;
  return update(state, {
    [resourceType]: {
      uploadFiles: {
        $apply: files => _.map(files, file => {
          if (file.name === name && file.folder === currentFolder) {
            switch (status) {
              case ERROR_FILE_UPLOAD_STATUS:
                return {...file, status: ERROR_FILE_UPLOAD_STATUS, errorMessage: error};
              case CANCELED_FILE_UPLOAD_STATUS:
                return {...file, status: CANCELED_FILE_UPLOAD_STATUS};
              default:
                return file;
            }
          }
          return file;
        }),
      }
    }
  });
}

function doRetryUploadFileInBar(state, action) {
  const {currentFolder, name, formData, url, cancelUpload, resourceType = 'Images'} = action.data;
  return update(state, {
    [resourceType]: {
      uploadFiles: {
        $apply: files => _.map(files, file => {
          if (file.name === name && file.folder === currentFolder) {
            return {
              url,
              ...file,
              cancelUpload,
              formData,
              status: LOADING_FILE_UPLOAD_STATUS,
              percent: 0,
            };
          }
          return file;
        }),
      }
    }
  });
}

function doChangeFileUploadPercent(state, action) {
  const {currentFolder, name, percent, resourceType = 'Images'} = action.data;
  return update(state, {
    [resourceType]: {
      uploadFiles: {
        $apply: files => _.map(files, file => {
          if (file.name === name && file.folder === currentFolder) {
            return {...file, percent};
          }
          return file;
        }),
      }
    }
  });
}

function doChangeFolder(state, action) {
  const selectedFolder = action.data.folderName;
  const resourceType = action.data.resourceType || 'Images';
  return update(state, {
    [resourceType]: {
      selectedFolder: {
        $set: selectedFolder,
      },
    },
  });
}

function doUpdateSearch(state, action) {
  const { search } = action.data;
  return update(state, {
    Images: {
      search: {
        $set: search,
      },
    },
  });
}

function doChangeSortDirection(state, action) {
  const { direction, resourceType } = action.data;
  return update(state, {
    [resourceType]: {
      sort: {
        $apply: sort => ({
          ...sort,
          direction,
        }),
      },
    },
  });
}

function doChangeSortField(state, action) {
  const { field, resourceType } = action.data;
  return update(state, {
    [resourceType]: {
      sort: {
        $apply: sort => ({
          ...sort,
          field,
        }),
      },
    },
  });
}

function doOpenSnackbar(state, action) {
  return update(state, {
    Images: {
      snackbarData: {
        $apply: snackbarData => ({
          ...snackbarData,
          ...action.data,
          open: true,
        }),
      },
    },
  });
}

function doCloseSnackbar(state, action) {
  return update(state, {
    Images: {
      snackbarData: {
        $apply: snackbarData => ({
          ...snackbarData,
          open: false,
          action: '',
          actionFunc: null,
          message: '',
        }),
      },
    },
  });
}

function doChangeView(state, action) {
  const { view, resourceType } = action.data;
  return update(state, {
    [resourceType]: {
      view: {
        $set: view,
      },
    },
  });
}

export default function reducer(state = {}, action = {}) {
  switch (action.type) {
    case UPDATE_FOLDERS:
      return doUpdateFolders(state, action);
    case UPDATE_FILES:
      return doUpdateFiles(state, action);
    case DELETE_FILES:
      return doDeleteFiles(setSelectedImages(state, { selected: [] }), action);
    case RENAME_FILE:
      return doRenameFile(setSelectedImages(state, { selected: [] }), action);
    case MOVE_FILES:
      return doMoveFiles(setSelectedImages(state, { selected: [] }), action);
    case UPLOAD_FILES:
      return doChangeFileStatusSuccess(doUploadFiles(state, action), action);
    case CHANGE_SEARCH_FILE:
      return doChangeSearchFile(state, action);
    case DELETE_FOLDER:
      return doDeleteFolder(state, action);
    case RENAME_FOLDER:
      return doRenameFolder(state, action);
    case CHANGE_FOLDER:
      return doChangeFolder(state, action);
    case PUSH_NEW_FOLDER:
      return doAddFolder(state, action);
    case PUSH_SELECTED_IMAGES:
      return pushSelectedImages(state, action);
    case POP_SELECTED_IMAGES:
      return popSelectedImages(state, action);
    case SET_SELECTED_IMAGES:
      return setSelectedImages(state, action);
    case PUSH_IMAGE_TO_BAR:
      return doPushImageToBar(state, action);
    case REMOVE_ALL_IMAGES_FROM_BAR:
      return doRemoveAllImagesFromBar(state, action);
    case CHANGE_FILE_STATUS_SUCCESS:
      return doChangeFileStatusSuccess(state, action);
    case CHANGE_FILE_STATUS_ERROR:
      return doChangeFileStatusError(state, action);
    case RETRY_UPLOAD_FILE_IN_BAR:
      return doRetryUploadFileInBar(state, action);
    case CHANGE_FILE_UPLOAD_PERCENT:
      return doChangeFileUploadPercent(state, action);
    case UPDATE_SEARCH:
      return doUpdateSearch(state, action);
    case CHANGE_SORT_DIRECTION:
      return doChangeSortDirection(state, action);
    case CHANGE_SORT_FIELD:
      return doChangeSortField(state, action);
    case OPEN_SNACKBAR:
      return doOpenSnackbar(state, action);
    case CLOSE_SNACKBAR:
      return doCloseSnackbar(state, action);
    case CHANGE_VIEW:
      return doChangeView(state, action);
    default:
      return state;
  }
}

export const updateFolders = makeActionCreator(UPDATE_FOLDERS, 'data');
export const updateFiles = makeActionCreator(UPDATE_FILES, 'data');
export const deleteFiles = makeActionCreator(DELETE_FILES, 'data');
export const renameFile = makeActionCreator(RENAME_FILE, 'data');
export const moveFiles = makeActionCreator(MOVE_FILES, 'data');
export const uploadFiles = makeActionCreator(UPLOAD_FILES, 'data');
export const changeSearchFile = makeActionCreator(CHANGE_SEARCH_FILE, 'data');
export const deleteFolder = makeActionCreator(DELETE_FOLDER, 'path');
export const addNewFolder = makeActionCreator(PUSH_NEW_FOLDER, 'data');
export const renameFolder = makeActionCreator(RENAME_FOLDER, 'data');
export const changeFolder = makeActionCreator(CHANGE_FOLDER, 'data');
export const updateSearch = makeActionCreator(UPDATE_SEARCH, 'data');

export const selectImages = makeActionCreator(PUSH_SELECTED_IMAGES, 'selected');
export const unselectImages = makeActionCreator(POP_SELECTED_IMAGES, 'selected');
export const replaceSelectedImages = makeActionCreator(SET_SELECTED_IMAGES, 'selected');
export const unselectAllImages = () => replaceSelectedImages([]);

export const pushImageToBar = makeActionCreator(PUSH_IMAGE_TO_BAR, 'data');
export const removeAllImagesFromBar = makeActionCreator(REMOVE_ALL_IMAGES_FROM_BAR, 'data');
export const changeFileStatusSuccess = makeActionCreator(CHANGE_FILE_STATUS_SUCCESS, 'data');
export const changeFileStatusError = makeActionCreator(CHANGE_FILE_STATUS_ERROR, 'data');
export const retryUploadFileInBar = makeActionCreator(RETRY_UPLOAD_FILE_IN_BAR, 'data');
export const changeFileUploadPercent = makeActionCreator(CHANGE_FILE_UPLOAD_PERCENT, 'data');

export const changeSortDirection = makeActionCreator(CHANGE_SORT_DIRECTION, 'data');
export const changeSortField = makeActionCreator(CHANGE_SORT_FIELD, 'data');

export const openSnackbar = makeActionCreator(OPEN_SNACKBAR, 'data');
export const closeSnackbar = makeActionCreator(CLOSE_SNACKBAR, 'data');

export const changeView = makeActionCreator(CHANGE_VIEW, 'data');
